import {
  CheckCircleIcon,
  InfoIcon,
  XCircleIcon,
  AlertCircleIcon,
} from 'lucide-react';
import { CouponIcon } from '../app/product/[slug]/components/icons/coupon';

type InformationBadgeProps = {
  type: 'neutral' | 'info' | 'success' | 'warning' | 'error' | 'coupon';
  text?: string;
  textComponent?: React.ReactNode;
  extraComponent?: React.ReactNode;
};

export const BADGE_CONFIG = {
  neutral: {
    background: '#F1F1F1',
    foreground: '#666666',
    icon: null,
  },
  info: {
    background: '#F1F1F1',
    foreground: '#C41819',
    icon: InfoIcon,
  },
  success: {
    background: '#E9F2E9',
    foreground: '#1E7A1E',
    icon: CheckCircleIcon,
  },
  warning: {
    background: '#FCF6E6',
    foreground: '#D8A100',
    icon: AlertCircleIcon,
  },
  error: {
    background: '#F9E7E7',
    foreground: '#C41819',
    icon: XCircleIcon,
  },
  coupon: {
    background: '#F1F1F1',
    foreground: '#000000',
    icon: CouponIcon,
  },
} as const;

export default function InformationBadge({
  type = 'neutral',
  text,
  textComponent,
  extraComponent,
}: InformationBadgeProps) {
  const config = BADGE_CONFIG[type];
  const Icon = config.icon;

  return (
    <div
      className="flex h-fit w-full items-center justify-between gap-x-6 rounded-[2rem] px-8 py-8 sm:h-[5rem] sm:py-2"
      style={{ backgroundColor: config.background }}
    >
      <div className="flex items-start gap-x-4 sm:items-center sm:gap-x-6">
        {Icon && (
          <Icon
            className="h-[2.5rem] w-[2.5rem] text-white"
            style={{ color: config.foreground }}
          />
        )}

        {textComponent ? (
          textComponent
        ) : (
          <p className="pt-1 text-[1.6rem] font-semibold text-black">{text}</p>
        )}
      </div>

      {extraComponent && extraComponent}
    </div>
  );
}
